import apiClient, { extractData } from "./client";
import { syncEmployeeDirectManagerQuietly } from "./organizationalHierarchy";

export async function getEmployees(params = {}) {
  const response = await apiClient.get("/employees", { params });
  return extractData(response);
}

export async function getEmployee(id) {
  const response = await apiClient.get(`/employees/${id}`);
  return extractData(response);
}

export async function getMyEmployee() {
  const response = await apiClient.get("/employees/me");
  return extractData(response);
}

export async function updateMyEmployee(data) {
  const response = await apiClient.patch("/employees/me", data);
  return extractData(response);
}

export async function createEmployee(data) {
  const response = await apiClient.post("/employees", data);
  const result = extractData(response);
  if (result?.id && data?.managerId) {
    await syncEmployeeDirectManagerQuietly(result.id, data.managerId);
  }
  return result;
}

export async function createEmployeeWithAccount(data) {
  const response = await apiClient.post("/employees/with-account", data);
  const result = extractData(response);
  if (result?.id && data?.managerId) {
    await syncEmployeeDirectManagerQuietly(result.id, data.managerId);
  }
  return result;
}

export async function updateEmployee(id, data) {
  const response = await apiClient.patch(`/employees/${id}`, data);
  const result = extractData(response);
  if (data && Object.prototype.hasOwnProperty.call(data, "managerId")) {
    await syncEmployeeDirectManagerQuietly(id, data.managerId || null);
  }
  return result;
}

export async function terminateEmployee(id, data = {}) {
  const response = await apiClient.post(`/employees/${id}/terminate`, data);
  return extractData(response);
}

export async function reactivateEmployee(id, data = {}) {
  const response = await apiClient.post(`/employees/${id}/reactivate`, data);
  return extractData(response);
}

export async function getEmployeeHistory(id, params = {}) {
  const response = await apiClient.get(`/employees/${id}/history`, { params });
  return extractData(response);
}

export async function lookupEmployeeByCode(code) {
  const response = await apiClient.get(
    `/employees/by-code/${encodeURIComponent(code.trim().toUpperCase())}`,
  );
  return extractData(response);
}

export async function linkEmployeeAccount(data) {
  const response = await apiClient.post("/employees/link-account", data);
  return extractData(response);
}

export async function resetEmployeePassword(id, password) {
  const response = await apiClient.post(`/employees/${id}/reset-password`, {
    password,
  });
  return extractData(response);
}
